import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import VN from "../components/VN";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Button,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@mui/material";
import { Row, Col, Container } from "react-bootstrap";
import { apiRequest } from "../components/Config";
import { UserDataContext } from "../components/UserDataContext";
import LocationSelect from "../components/LocationSelect";
import PasswordFields from "../components/PasswordFields";
import { API_URL } from "../App";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import Alerts from "../components/Alerts";

export default function RegisterClient() {
  const { userData } = useContext(UserDataContext);
  const navigate = useNavigate();
  const [voivodeshipList, setVoivodeshipList] = useState([]);
  const [textEmail, setTextEmail] = useState("");
  const [showTextEmail, setShowTextEmail] = useState(false);
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState("");
  const [textPhone, setTextPhone] = useState("");
  const [showTextPhone, setShowTextPhone] = useState(false);
  const [showEmailVerifyInput, setShowEmailVerifyInput] = useState(false);
  const [emailCode, setEmailCode] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const [verifyMessage, setVerifyMessage] = useState("");
  const [showSubmit, setShowSubmit] = useState(true);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);

  useEffect(() => {
    apiRequest("voivodeship").then(setVoivodeshipList);
  }, []);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Podaj poprawny email")
      .required("Email jest wymagany"),
    phone: Yup.string()
      .required("Telefon jest wymagany")
      .length(9, "Telefon musi mieć 9 cyfr"),
    fullName: Yup.string().required("Nazwisko i imię wymagane"),
    password: Yup.string().min(6, "Min. 6 znaków").required("Hasło wymagane"),
    passwordrepeat: Yup.string()
      .oneOf([Yup.ref("password")], "Hasła muszą być identyczne")
      .required("Powtórz hasło"),
    voivodeship: Yup.string().required("Wybierz województwo"),
    city: Yup.object().nullable().required("Wybierz miasto"),
    rodo: Yup.boolean().oneOf([true], "Wymagana zgoda"),
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!email) return;
      const url = API_URL + `/verify-account-email`;
      try {
        const response = await axios.post(url, { email: email });
        if (parseInt(response.data.email) > 0) {
          setTextEmail("Taki email już istnieje w systemie!");
          setShowTextEmail(true);
          setShowSubmit(false);
        } else {
          setShowTextEmail(false);
          setShowSubmit(true);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, [email]);

  useEffect(() => {
    const fetchData = async () => {
      if (!phone) return;
      const url = API_URL + `/verify-account-phone`;
      try {
        const response = await axios.post(url, { phone: phone });
        if (parseInt(response.data.phone) > 0) {
          setTextPhone("Taki numer już istnieje w systemie!");
          setShowTextPhone(true);
          setShowSubmit(false);
        } else {
          setShowTextPhone(false);
          setShowSubmit(true);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, [phone]);

  return (
    <div>
      <VN userData={userData} />
      {showApiResponse && (
        <Row className="sticky-alerts-container">
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Container>
        <Box mt={5}>
          <h1>Rejestracja osoby poszukającej opiekunki</h1>

          <Formik
            initialValues={{
              email: "",
              phone: "",
              fullName: "",
              password: "",
              passwordrepeat: "",
              voivodeship: "",
              city: null,
              rodo: false,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => {
              if (!captchaToken) {
                setApiResponse({
                  title: "Potwierdź captcha",
                  severity: "warning",
                  info: "Potwierdzenie captcha wymagane",
                });
                setShowApiResponse(true);
                return;
              }
              console.log("Payload wysyłany do /register-client:", {
                ...values,
                city: values.city.id,
                captcha: captchaToken,
                accountType: 2,
                email_verified: emailVerified,
              });

              const res = await apiRequest("register-client", "POST", {
                ...values,
                city: values.city.id,
                captcha: captchaToken,
                accountType: 2,
                email_verified: emailVerified,
              });
              console.log("register-client: ", res);
              if (res.error_msg === 200) {
                setApiResponse({
                  title: "Informacja",
                  severity: "success",
                  info: "Konto założone poprawnie. Za chwilę zostaniesz przekierowany na stronę logowania",
                });

                setShowApiResponse(true);

                setTimeout(() => {
                  setShowApiResponse(false);
                  navigate("/login", { state: { registered: true } });
                }, 5000);
              }
              if (res.error_msg === 555) {
                setApiResponse({
                  title: "Informacja",
                  severity: "warning",
                  info: "Mail nie został zweryfikowany. Dane nie zostały zapisane",
                });

                setShowApiResponse(true);

                setTimeout(() => {
                  setShowApiResponse(false);
                }, 5000);
              }
              if (res.error_msg === 403) {
                setApiResponse({
                  title: "Informacja",
                  severity: "warning",
                  info: "Captcha nie zweryfikowana. Odśwież formularz i spróbuj ponownie.",
                });
                setShowApiResponse(true);
              }

              /*
              navigate("/login", { state: { registered: true } });
              */
            }}
          >
            {({ values, handleChange, setFieldValue, errors, touched }) => (
              <Form>
                <Row>
                  <Col xs={12} md={4}>
                    <TextField
                      name="email"
                      label="Email"
                      fullWidth
                      margin="normal"
                      value={values.email}
                      onChange={(e) => {
                        handleChange(e);
                        setEmail(e.target.value);
                      }}
                      error={touched.email && Boolean(errors.email)}
                      helperText={touched.email && errors.email}
                    />
                    {showTextEmail && (
                      <Typography color="error">{textEmail}</Typography>
                    )}

                    {!emailVerified && values.email && !showTextEmail && (
                      <Button
                        size="small"
                        variant="outlined"
                        sx={{ mt: 1 }}
                        onClick={async () => {
                          await apiRequest("send-email-code-register", "POST", {
                            email: values.email,
                          });
                          setShowEmailVerifyInput(true);
                          setVerifyMessage("Kod został wysłany na email");
                        }}
                      >
                        Zweryfikuj email
                      </Button>
                    )}
                    {showEmailVerifyInput && !emailVerified && (
                      <Box display="flex" gap={1} alignItems="center" mt={1}>
                        <TextField
                          label="Kod z emaila"
                          value={emailCode}
                          onChange={(e) => setEmailCode(e.target.value)}
                          size="small"
                          fullWidth
                        />
                        <Button
                          variant="contained"
                          size="small"
                          onClick={async () => {
                            const response = await apiRequest(
                              "verify-email-code-register",
                              "POST",
                              {
                                email: values.email,
                                code: emailCode,
                              },
                            );
                            if (response.success) {
                              setEmailVerified(true);
                              setVerifyMessage("Email zweryfikowany ✔");
                              setShowSubmit(true);
                            } else {
                              setVerifyMessage("Nieprawidłowy kod");
                              setShowSubmit(false);
                            }
                          }}
                        >
                          OK
                        </Button>
                      </Box>
                    )}
                    {verifyMessage && (
                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          color: emailVerified ? "green" : "orange",
                        }}
                      >
                        {verifyMessage}
                      </Typography>
                    )}
                  </Col>
                  <Col xs={12} md={4}>
                    <TextField
                      name="fullName"
                      label="Nazwisko i Imię"
                      fullWidth
                      margin="normal"
                      value={values.fullName}
                      onChange={handleChange}
                      error={touched.fullName && Boolean(errors.fullName)}
                      helperText={touched.fullName && errors.fullName}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <TextField
                      name="phone"
                      label="Telefon"
                      fullWidth
                      margin="normal"
                      value={values.phone}
                      onChange={(e) => {
                        const val = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 9);
                        setFieldValue("phone", val);
                        setPhone(val);
                      }}
                      error={touched.phone && Boolean(errors.phone)}
                      helperText={touched.phone && errors.phone}
                    />
                    {showTextPhone && (
                      <Typography color="error">{textPhone}</Typography>
                    )}
                  </Col>
                </Row>
                <Row>
                  <PasswordFields
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    touched={touched}
                  />
                </Row>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    margin: "20px 0",
                    padding: "15px",
                    border: "1px solid #ced4da",
                    borderRadius: "8px",
                    backgroundColor: "#f8f9fa",
                    color: "#495057",
                    fontWeight: "500",
                  }}
                >
                  Poniżej wybierz województwo i miasto, w którym szukasz
                  opiekunki
                </Row>
                <Row>
                  <LocationSelect
                    values={values}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                  />
                </Row>
                <Row>
                  <Col xs={12} md={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="rodo"
                          checked={values.rodo}
                          onChange={handleChange}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="body2">
                          Wyrażam zgodę na przetwarzanie danych zgodnie z{" "}
                          <a href="/polityka-prywatnosci" target="_blank">
                            Polityką prywatności
                          </a>
                          .
                        </Typography>
                      }
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Box mt={2}>
                      <ReCAPTCHA
                        sitekey="6Ld8dZcsAAAAAI2kdXLZVwduM4ydXysrZRJju4qo"
                        onChange={setCaptchaToken}
                      />
                    </Box>
                  </Col>
                </Row>
                {touched.rodo && errors.rodo && (
                  <FormHelperText error>{errors.rodo}</FormHelperText>
                )}
                {showSubmit && (
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 2 }}
                  >
                    Zarejestruj
                  </Button>
                )}
              </Form>
            )}
          </Formik>
        </Box>
      </Container>
    </div>
  );
}
